import React, { useState } from "react";
import DashboardDocumenten from "../../Componenten/DashboardDocumenten";
import FilterNavigation from "../../Componenten/Dashboard/FilterNavigation";
import FileCard from "../../Componenten/MiniCards/FileCard";
import { DocumentIcon, TableCellsIcon } from "@heroicons/react/24/outline";
import FileCardAdvies from "../../Componenten/MiniCards/FileCardAdvies";
import FileCardPlans from "../../Componenten/MiniCards/FileCardPlans";
import SelectPatienten from "../../Componenten/SelectPatienten";

const filters = [
  { value: 1, name: "list", icon: TableCellsIcon, color: "text-green-500" },
  { value: 2, name: "block", icon: DocumentIcon, color: "text-green-500" },
];

const DocumentAdmin = ({
  userdetails,
  setPatient,
  patient,
  patienten,
  attachments,
  type = "uploads",
}) => {
  const [view, setView] = useState(filters[0]);

  return (
    <div className="mx-auto w-full bg-wa-app px-4 pt-6 sm:px-6 lg:px-8">
      <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
        <FilterNavigation
          selectedRadio={view}
          setSelectedRadio={setView}
          options={filters}
        />
        <div className="md:min-w-[280px]">
          { patienten?.length > 0 ? (
            <SelectPatienten
              selected={patient ? patient : patienten[0]}
              setSelected={setPatient}
              data={patienten}
            />
          ) : null}
        </div>
      </div>
      {view?.value === 1 ? (
        <DashboardDocumenten
          attachments={attachments}
          patienten={patienten}
          patient={patient}
          user={userdetails}
        />
      ) : (
        <div className="mt-4 grid grid-cols-1 gap-3 md:grid-cols-2 xl:grid-cols-3 xxl:grid-cols-4">
          {attachments?.length > 0
            ? attachments.map((item) => (
                <div key={item?.id || item?.url || item?.bestand}>
                  {type === "uploads" ? (
                    <FileCard item={item} userdetails={userdetails} />
                  ) : type === "advies" ? (
                    <FileCardAdvies item={item} userdetails={userdetails} />
                  ) : (
                    <FileCardPlans item={item} userdetails={userdetails} />
                  )}
                </div>
              ))
            : (
              <div className="col-span-full rounded-lg border border-wa-border bg-wa-panel p-8 text-center text-wa-muted">
                <p>Er zijn geen documenten gevonden.</p>
              </div>
            )}
        </div>
      )}
    </div>
  );
};

export default DocumentAdmin;
